import React, { useState } from 'react'
import { Card, Input, Button, message, Typography } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'

const { Title, Text } = Typography

const LoginPage: React.FC = () => {
  const [loading, setLoading] = useState(false)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const { login, getDefaultRoute } = useAuthStore()
  const navigate = useNavigate()

  const handleLogin = async () => {
    if (loading) return

    if (!username.trim() || !password) {
      message.error('请输入账号和密码')
      return
    }

    setLoading(true)

    try {
      await login(username.trim(), password)
      message.success(`欢迎，${username.trim()}！`)

      const defaultRoute = getDefaultRoute()
      setTimeout(() => {
        navigate(defaultRoute)
      }, 800)
    } catch (error) {
      message.error(error instanceof Error ? error.message : '登录失败，请重试')
    } finally {
      setLoading(false)
    }
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleLogin()
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'radial-gradient(circle at 20% 20%, rgba(214,177,102,0.08), transparent 35%), radial-gradient(circle at 80% 0%, rgba(88,126,188,0.08), transparent 30%), var(--bg)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{ width: '100%', maxWidth: '400px' }}>
        <div style={{
          textAlign: 'center',
          marginBottom: 40,
          color: 'var(--text)'
        }}>
          <div style={{
            fontSize: 60,
            marginBottom: 16,
            fontWeight: 700,
            letterSpacing: 2
          }}>
            🚛
          </div>
          <Title level={1} style={{
            color: 'var(--text)',
            marginBottom: 8,
            fontWeight: 700
          }}>
            叉车管理系统
          </Title>
          <Text style={{
            color: 'var(--muted)',
            fontSize: 16,
            fontWeight: 500
          }}>
            云端登录
          </Text>
        </div>

        <Card
          style={{
            borderRadius: '18px',
            boxShadow: '0 20px 60px rgba(0,0,0,0.35)',
            border: '1px solid var(--line)',
            background: 'linear-gradient(145deg, rgba(17,24,36,0.9), rgba(22,30,44,0.9))',
            backdropFilter: 'blur(6px)'
          }}
        >
          <div style={{ padding: '8px 0' }}>
            <Title level={4} style={{
              textAlign: 'center',
              marginBottom: 32,
              color: 'var(--accent)'
            }}>
              用户登录
            </Title>

            <div style={{ marginBottom: 24 }}>
              <Text strong style={{
                display: 'block',
                marginBottom: 8,
                color: 'var(--text)'
              }}>
                账号
              </Text>
              <Input
                size="large"
                prefix={<UserOutlined style={{ color: 'var(--muted)' }} />}
                placeholder="请输入账号"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onKeyPress={handleKeyPress}
                maxLength={64}
                style={{
                  borderRadius: '8px',
                  height: '48px'
                }}
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <Text strong style={{
                display: 'block',
                marginBottom: 8,
                color: 'var(--text)'
              }}>
                密码
              </Text>
              <Input.Password
                size="large"
                placeholder="请输入密码"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={handleKeyPress}
                style={{
                  borderRadius: '8px',
                  height: '48px'
                }}
              />
            </div>

            <Button
              type="primary"
              size="large"
              loading={loading}
              disabled={loading || !username || !password}
              onClick={handleLogin}
              block
              style={{
                height: '48px',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: 600,
                background: 'var(--accent-strong)',
                borderColor: 'var(--accent-strong)'
              }}
            >
              登录
            </Button>
          </div>
        </Card>

        <div style={{
          textAlign: 'center',
          marginTop: 24,
          color: 'var(--muted)'
        }}>
          <Text style={{
            color: 'var(--muted)',
            fontSize: 14
          }}>
            叉车租赁财务工作流管理平台
          </Text>
        </div>
      </div>
    </div>
  )
}

export default LoginPage
